var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#F8F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78011 9.81329L8.27255 12.3055C8.38405 12.4172 8.43905 12.5477 8.43755 12.6972C8.43617 12.8467 8.3773 12.9797 8.26092 13.096C8.14455 13.2047 8.0128 13.2609 7.86567 13.2648C7.71867 13.2685 7.58698 13.2123 7.47061 13.096L4.09992 9.72536C3.9643 9.58973 3.89648 9.43154 3.89648 9.25079C3.89648 9.07004 3.9643 8.91186 4.09992 8.77623L7.47061 5.40554C7.57448 5.30179 7.70305 5.24867 7.8563 5.24617C8.00967 5.24379 8.14455 5.29692 8.26092 5.40554C8.3773 5.52192 8.43548 5.65561 8.43548 5.80661C8.43548 5.95748 8.3773 6.09111 8.26092 6.20748L5.78011 8.68829H12.8129C13.7975 8.68829 14.6374 9.03592 15.3325 9.73117C16.0277 10.4263 16.3754 11.2662 16.3754 12.2508V14.3133C16.3754 14.4729 16.3215 14.6065 16.2137 14.7142C16.1061 14.8219 15.9725 14.8758 15.8129 14.8758C15.6532 14.8758 15.5196 14.8219 15.412 14.7142C15.3042 14.6065 15.2504 14.4729 15.2504 14.3133V12.2508C15.2504 11.5777 15.0124 11.0032 14.5364 10.5273C14.0605 10.0513 13.486 9.81329 12.8129 9.81329H5.78011Z",
    fill: "#0064E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplied);
export default __webpack_public_path__ + "static/media/Replied.37b763982f2fcb3f4f885182a508b88c.svg";
export { ForwardRef as ReactComponent };